package horcrux.frontend.common.views.chat

import horcrux.frontend.common.configs.StaticContentConfigs
import js.objects.jso
import mui.material.Avatar
import mui.material.AvatarProps
import mui.system.ThemeProvider
import mui.system.sx
import react.FC
import react.Props
import web.cssom.pt
import web.cssom.px

external interface AvatarWithThemeProps : AvatarProps

val AvatarWithTheme = FC<AvatarWithThemeProps> { props ->
    ThemeProvider {
        this.theme = Theme.theme
        Avatar { +props }
    }
}

external interface GrokAppAvatarProps : Props {
    var messageSenderData: MessageSenderData
}

val GrokAppAvatar = FC<GrokAppAvatarProps> { props ->
    AvatarWithTheme {
        this.src = StaticContentConfigs.LOGO_NO_TEXT_PATH
        this.alt = props.messageSenderData.avatarLabel
        this.style = jso {
            this.width = 20.px
            this.height = 20.px
        }
        this.sx {
            this.marginRight = 3.pt
        }
    }
}

external interface UserAvatarProps : Props {
    var messageSenderData: User
}

val UserAvatar = FC<UserAvatarProps> { props ->
    AvatarWithTheme {
        +(props.messageSenderData.email.firstOrNull()?.uppercase() ?: "D")
        this.alt = props.messageSenderData.avatarLabel
        this.style = jso {
            this.width = 20.px
            this.height = 20.px
        }
        this.sx {
            this.marginRight = 3.pt
            this.backgroundColor = StaticContentConfigs.BLUE
        }
    }
}
